function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/*
 Contextual naming for shared control styling
 Used by textarea and input
*/

var inputBase = () => {
  return {
    color: 'black',
    borderColor: 'grey.800',
    boxShadowColor: 'none',
    placeHolderColor: 'grey.800',
    bg: 'white',
    borderRadius: '3px',
    borderWidth: '1px',
    errorTextColor: 'red.850'
  };
};
export var inputBaseStyles = {
  base: inputBase(),
  focus: _objectSpread(_objectSpread({}, inputBase()), {}, {
    borderColor: 'blue.275',
    bg: 'grey.250',
    boxShadowColor: 'blue.300'
  }),
  disabled: _objectSpread(_objectSpread({}, inputBase()), {}, {
    borderColor: 'grey.400',
    color: 'grey.800',
    bg: 'grey.250',
    borderWidth: '1px'
  }),
  invalid: _objectSpread(_objectSpread({}, inputBase()), {}, {
    borderColor: 'red.850',
    borderWidth: '1.5px'
  }),
  invalidFocus: _objectSpread(_objectSpread({}, inputBase()), {}, {
    borderColor: 'red.850',
    boxShadowColor: 'red.850',
    borderWidth: '1.5px'
  })
};
export var errorBaseStyles = {
  requiredIndicatorColor: 'red.850',
  errorTextColor: 'red.850'
};